module.exports = __webpack_public_path__ + "img/icon-vot-addsponsor.f9832385.png";